import React from 'react'
import './Home.css'
import logo from '../../assets/img/logo.png'
import heroImg from '../../assets/img/hero.jpg'
import heroTwo from '../../assets/img/hero-two.png'
import heroThree from '../../assets/img/hero-three.png'
import yashLogo from '../../assets/img/yash.png'
import themeOneHero from '../../assets/img/hero-works-two.png'
import themeTwoHero from '../../assets/img/hero-works-one.png'
import themeThreeHero from '../../assets/img/hero-works-three.png'
import PaygeItem from '../../components/PaygeItem/PaygeItem'
// vectors
import { ReactComponent as DottedCircle } from '../../assets/vectors/dotted-circle.svg'
import { ReactComponent as DottedSquare } from '../../assets/vectors/dotted-square.svg'
import { ReactComponent as DottedRectangle } from '../../assets/vectors/dotted-rectangle.svg'
import { ReactComponent as DottedLine } from '../../assets/vectors/dotted-line.svg'
import { ReactComponent as DottedTriangle } from '../../assets/vectors/dotted-triangle.svg'
import { ReactComponent as HeroImage } from '../../assets/vectors/hero.svg'

import * as firebase from "firebase/app"
import "firebase/auth"
import axios from 'axios'
import Modal from 'react-modal'
import { Helmet } from 'react-helmet'
import { ArrowForward, Check, CheckCircle, ArrowBack } from '@material-ui/icons'
import { API_URL } from '../../config'

const yt_modal_styles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		width: '60%',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		padding: 0,
		background: '#0091EA',
		borderRadius: 0,
	}
}

const free_features = [
	"Beautiful download pages",
	"Short links to download pages",
	"3 download page themes"
]
const soon_features = [
	"Paid downloads",
	"No powered by Payge branding",
	"Payge Analytics",
	"Expiring download pages",
	"Beautiful download pages",
	"Short links to download pages",
	"3 download page themes",
]

const login_conditions = [
	"Zero promotional emails",
	"Only urgent & important emails",
	"No credit card required"
]

const img_one = "https://images.unsplash.com/photo-1561016444-14f747499547?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1489&q=80"
const theme_one_bg = "https://images.unsplash.com/photo-1524222835726-8e7d453fa83c?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1080&fit=max&ixid=eyJhcHBfaWQiOjEyODM3M30"
const theme_two_bg = "https://images.unsplash.com/photo-1504465039710-0f49c0a47eb7?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1080&fit=max&ixid=eyJhcHBfaWQiOjEyODM3M30"
const theme_three_bg = "https://images.unsplash.com/photo-1585369111972-771555a164c5?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1080&fit=max&ixid=eyJhcHBfaWQiOjEyODM3M30"
const default_background = {
  index: 0,
  imgSearchQuery: 'payge_default_background_image',
  urls: {
    regular: img_one
  },
  user: {
    name: "Jason Dent",
    links: {html: "https://unsplash.com/@jdent"}
  }
}

// Firebase Auth
var googleProvider = new firebase.auth.GoogleAuthProvider()
var facebookProvider = new firebase.auth.FacebookAuthProvider()

export default class Home extends React.Component {

	constructor(props) {
		super(props)
		this.state = {
			video_isopen: false,
			login_isopen: false,
			signup_isopen: false,
			nameInputText: '',
			emailInputText: '',
			passwordInputText: '',
			paygeDemoTheme: 'one',
			currentUser: undefined,
			yt_video_id: 'zfcOlRtf7lo'
		}
	}

	handleVideoExit() {
		if (this.state.video_isopen) {
			this.setState({video_isopen: false})
		}
	}
	
	openVideoModal(tutorial_num) {
		let video_id = 'zfcOlRtf7lo'
		if (tutorial_num === 2) {
			video_id = 'WiAS15V6sXs'
		} else if (tutorial_num === 3) {
			video_id = '9P6TnEs1KCU'
		}
		this.setState({video_isopen: true, yt_video_id: video_id})
	}
	openLoginModal(isLogin) {
		const { currentUser } = this.state
		if (currentUser) {
			// User is signed in.
			window.open('/dashboard', '_self')
		} else {
			// No user is signed in.
			this.setState({login_isopen: isLogin, signup_isopen: !isLogin})
		}
	}
	closeLoginModal() {
		this.setState({login_isopen: false, signup_isopen: false})
	}

	handleAuthNameChange = (e) => { this.setState({nameInputText: e.target.value}) }
	handleAuthEmailChange = (e) => { this.setState({emailInputText: e.target.value}) }
	handleAuthPasswordChange = (e) => { this.setState({passwordInputText: e.target.value}) }

	// auth request
	handleEmailAuthRequest = () => {
		const { login_isopen, signup_isopen, nameInputText, emailInputText, passwordInputText } = this.state
		if (login_isopen) {
			// checking for empty inputs
			if (emailInputText.trim() !== "" && passwordInputText.trim() !== "") {
				firebase.auth().signInWithEmailAndPassword(emailInputText, passwordInputText)
				.then(function (user) {
					if ((!user.user.displayName || user.user.displayName === "") && nameInputText.trim() !== "") {
						user.user.updateProfile({
							displayName: nameInputText
						})
					}
					// adding data to db
					axios({
						method: 'POST',
						url: `${API_URL}/user/new`,
						headers: {
							'Content-Type': 'application/json',
						},
						data: {
							email: user.user.email, 
							displayName: user.user.displayName, 
							uid: user.user.uid, 
							phone: user.user.phoneNumber,
							photoUrl: user.user.photoURL,
							providerId: user.user.providerId
						}
					}).then((result) => {
						if (result.status === 200) {
							window.open('/dashboard', '_self')
						}
					})
				})
				.catch(error => {
					// Handle Errors here.
					console.log(error.code)
					console.log(error.message)
					// ...
				})
			}
		} else if (signup_isopen) {
			// checking for empty inputs
			if (nameInputText.trim() !== "" && emailInputText.trim() !== "" && passwordInputText.trim() !== "") {
				firebase.auth().createUserWithEmailAndPassword(emailInputText, passwordInputText)
				.then(function (user) {
					user.user.updateProfile({
						displayName: nameInputText
					})
					// adding data to db
					axios({
						method: 'POST',
						url: `${API_URL}/user/new`,
						headers: {
							'Content-Type': 'application/json',
						},
						data: {
							email: user.user.email, 
							displayName: user.user.displayName, 
							uid: user.user.uid, 
							phone: user.user.phoneNumber,
							photoUrl: user.user.photoURL,
							providerId: user.user.providerId
						}
					}).then((result) => {
						if (result.status === 200) {
							window.open('/dashboard', '_self')
						}
					})
				})
				.catch(error => {
					// Handle Errors here.
					console.log(error.code)
					console.log(error.message)
					// ...
				})
			}
		}
	}
	handleOnKeyDown = (e) => {
		if (e.keyCode === 13) this.handleEmailAuthRequest()
	}
	handleSocialAuthRequest = (isGoogle) => {
		let provider = facebookProvider
		if (isGoogle) {
			provider = googleProvider
		}
		// signing in using firebase
		firebase.auth().signInWithPopup(provider).then(function(result) {
			// google access token
			var token = result.credential.accessToken;
			// Redirecting to dashboard
			var user = result.user;
			axios({
				method: 'POST',
				url: `${API_URL}/user/new`,
				headers: {
					'Content-Type': 'application/json',
				},
				data: {
					email: user.email, 
					displayName: user.displayName, 
					uid: user.uid, 
					phone: user.phoneNumber,
					photoUrl: user.photoURL,
					providerId: user.providerId
				}
			}).then((result) => {
				if (result.status === 200) {
					window.open('/dashboard', '_self')
				}
			})

		}).catch(function(error) {
			// Handle Errors here.
			var errorCode = error.code;
			var errorMessage = error.message;
			var email = error.email;
			var credential = error.credential;
		});
	}

	componentWillMount() {
		let self = this
		// firebase auth listener
    firebase.auth().onAuthStateChanged(function(user) {
			let currentUser = undefined
      if (user) {
        // User is signed in.
        currentUser = user
			}
			self.setState({currentUser: currentUser})
		})
	}

	componentDidMount() {
		// getting freshdesk
		const script = document.createElement("script")
    script.innerHTML = `function initFreshChat() {
			window.fcWidget.init({
				token: "fb1434a6-ddb7-4222-b6fa-16f3b83e457e",
				host: "https://wchat.in.freshchat.com"
			});
		}
		function initialize(i,t){var e;i.getElementById(t)?initFreshChat():((e=i.createElement("script")).id=t,e.async=!0,e.src="https://wchat.in.freshchat.com/js/widget.js",e.onload=initFreshChat,i.head.appendChild(e))}function initiateCall(){initialize(document,"freshchat-js-sdk")}window.addEventListener?window.addEventListener("load",initiateCall,!1):window.attachEvent("load",initiateCall,!1);`
    script.async = true
    document.body.appendChild(script)
	}

	render() {
		const { video_isopen, login_isopen, signup_isopen, nameInputText, emailInputText, passwordInputText, paygeDemoTheme, 
			currentUser, yt_video_id } = this.state

		// getting demo styles
		let demoOneSelectStyles = 'inactive'
		let demoTwoSelectStyles = 'inactive'
		let demoThreeSelectStyles = 'inactive'
		let themeHeroImage = undefined
		let themeDownloadName = undefined
		let themeDownloadDescription = undefined
		let themeDriveFile = undefined
		let themeBg = img_one
		switch(paygeDemoTheme) {
			case 'one':
				demoOneSelectStyles = 'active'
				themeHeroImage = themeOneHero
				themeDownloadName = 'E-Book'
				themeDownloadDescription = 'An ebook version of my grandma\'s most yummiest recipes.'
				themeDriveFile = {
					fileExtension: 'pdf',
					downloadUrl: '#',
					fileSize: '2300000'
				}
				themeBg = theme_one_bg
				break
			case 'two':
				demoTwoSelectStyles = 'active'
				themeHeroImage = themeTwoHero
				themeDownloadName = 'Press Kit'
				themeDownloadDescription = 'Contains logos, icons and brand guidelines to use our press kit resources for press releases and publications.'
				themeDriveFile = {
					fileExtension: 'pdf',
					downloadUrl: '#',
					fileSize: '5610000'
				}
				themeBg = theme_two_bg
				break
			case 'three':
				demoThreeSelectStyles = 'active'
				themeHeroImage = themeThreeHero
				themeDownloadName = 'Android Game'
				themeDownloadDescription = 'Android app file for a new game we just finished developing, try out this beta version from the download!'
				themeDriveFile = {
					fileExtension: 'apk',
					downloadUrl: '#',
					fileSize: '40180000'
				}
				themeBg = theme_three_bg
				break
		}

		// tos helper text
		let in_up_text = 'in'
		if (signup_isopen) { in_up_text = 'up' }

		return (
			<div style={{background: '#fff'}}>

				<section className="topbar">
					<a href="/"><div className="logo">
						<img src={logo} className="logo-img"/>
						<span className="logo-text">Payge</span>
					</div></a>
					<span className="login-btn" onClick={() => this.openLoginModal(true)}>{ currentUser ? 'Go to Dashboard' : 'Login'}</span>
				</section>

				<section id="landing-content">
					<div className="side-content">
						<span className="description-title">
							Create a landing page for your files
						</span>
						<span className="description-subtitle">
							Neat & simple download pages for your files! Upload the file to Google Drive or Dropbox, add the file to Payge and get your download page instantly!
						</span>
						<div className="get-started-btn" onClick={() => this.openLoginModal(false)}>
							Get Started for Free
							<ArrowForward />
						</div>
					</div>

					<div className="right-side-container">
						<HeroImage className="hero-img"/>
					</div>
				</section>

				<section id="demo-section">
					<span className="demo-title">This is how it looks!</span>
					<div className="theme-select-container">
						<img src={themeHeroImage} className="theme-img" />
						<ul className="theme-options">
							<li className={demoOneSelectStyles} onClick={()=>this.setState({paygeDemoTheme: 'one'})}>Theme One</li>
							<li className={demoTwoSelectStyles} onClick={()=>this.setState({paygeDemoTheme: 'two'})}>Theme Two</li>
							<li className={demoThreeSelectStyles} onClick={()=>this.setState({paygeDemoTheme: 'three'})}>Theme Three</li>
						</ul>
					</div>
					<div className={`preview-container ${paygeDemoTheme}`}>
						<img src={themeBg} className="preview-bg" />
						<PaygeItem 
							theme={paygeDemoTheme} 
							isLoaded={true} 
							name={themeDownloadName} 
							description={themeDownloadDescription}
							driveFile={themeDriveFile}
              isDemo={true} />
					</div>
				</section>

				<section id="works-section">
					<div className="works-img-holder">
						<img src={heroTwo} className="hero-two"/>
						<div className="works-container">
							<ul className="works-steps">
								<li>
									<span className="step-num">1</span>
									<div className="step-info-container">
										<span className="step-info" style={{paddingLeft: 12}}>Upload your file to Google Drive/Dropbox</span>
										<span className="step-how" onClick={() => this.openVideoModal(1)}>?</span>
									</div>
								</li>
								<li>
									<span className="step-num">2</span>
									<div className="step-info-container">
										<span className="step-info">Add the file to Payge using our Payge Creator</span>
										<span className="step-how" onClick={() => this.openVideoModal(2)}>?</span>	
									</div>
								</li>
								<li>
									<span className="step-num">3</span>
									<div className="step-info-container">
										<span className="step-info">Generate a neat and shareable download page instantly</span>
										<span className="step-how" onClick={() => this.openVideoModal(3)}>?</span>
									</div>
								</li>
							</ul>
						</div>
						<img src={heroThree} className="hero-three" />
					</div>
				</section>

				<section id="pricing-section">
					<DottedCircle className="vector right blue x-m r-half side-circle" />
					<DottedRectangle className="vector left animated blue x-m side-rect" />
					<DottedSquare className="vector green x-s slanted-square" />
					<DottedLine className="vector red x-s right-line" />
					<DottedTriangle className="vector yellow x-s right-triangle" />
					<div className="pricing-container">
						<div className="free-section">
							<span className="price-text">Free</span>
							<ul className="features">
								{
									free_features.map((feature) => {
										return (
											<li>
												<Check className="check-icon" />
												<span className="feature">{feature}</span>	
											</li>
										)
									})
								}
							</ul>
						</div>
						<div className="soon-section">
							<span className="price-text">
								{/* $5 <strike className="striked">$10</strike> */}
								Coming Soon
								<div className="pro-container">Pro</div>
							</span>
							<ul className="features">
								{
									soon_features.map((feature) => {
										return (
											<li>
												<Check className="check-icon blue" />
												<span className="feature">{feature}</span>
											</li>
										)
									})
								}
							</ul>
						</div>
					</div>
				</section>

				<section id="footer-section">
					<a href="https://hoooooop.com"><img src={yashLogo} className="yash-logo" /></a>
				</section>

				<Modal
					isOpen={ video_isopen }
					ariaHideApp={false}
					contentLabel="How to?"
					style={yt_modal_styles}
					onRequestClose={this.handleVideoExit.bind(this)}
					shouldCloseOnOverlayClick={true}
					id="video-modal">
					<div id="headerPopup" class="mfp-hide embed-responsive embed-responsive-21by9">
						<iframe class="embed-responsive-item" width="854" height="480" src={`https://www.youtube.com/embed/${yt_video_id}?autoplay=1`} frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
					</div>
				</Modal>

				<Modal
					isOpen={ (login_isopen || signup_isopen) }
					ariaHideApp={false}
					contentLabel="Login"
					className="login-modal"
					id="login-modal"
					onRequestClose={this.closeLoginModal.bind(this)}
					shouldCloseOnOverlayClick={true}>
					<ArrowBack className="back-icon" onClick={this.closeLoginModal.bind(this)} />
					<div className="login-modal-container">
						<div className="login-title-container">
							<span className="login-title">
								{ login_isopen ? "Sign in" : "Sign up" }
							</span>
							{/* <div className="dot" /> */}
							<span className="sublogin-title" onClick={() => this.openLoginModal(!login_isopen)}>
								{ login_isopen ? "Go to Sign up" : "Go to Sign in" }
							</span>
						</div>

						{
							login_isopen ? false : (
								<ul className="conditions">
									{
										login_conditions.map((condition) => {
											return (
												<li>
													<Check className="check-icon"/>
													<span className="condition">{condition}</span>
												</li>
											)
										})
									}
								</ul>
							)
						}
						<div style={{marginTop: 28}}>
							{
								login_isopen ? false : (
									<input type="name" placeholder="Full Name" value={nameInputText} onChange={this.handleAuthNameChange.bind(this)}/>
								)
							}
							<input type="email" placeholder="Email" value={emailInputText} onChange={this.handleAuthEmailChange.bind(this)}/>
							<input 
								type="password" placeholder="Password" 
								value={passwordInputText} onChange={this.handleAuthPasswordChange.bind(this)} 
								onKeyDown={this.handleOnKeyDown}/>
							<div className="login-btn" onClick={this.handleEmailAuthRequest.bind(this)}>
								{ login_isopen ? "Sign In" : "Sign Up"} 
								<ArrowForward className="login-icon"/>
							</div>
						</div>

						<div className="social-login-container">
							<span className="title">We have quicker ways too!</span>
							<div className="social-btn-holder">
								<div className="social-btn google" onClick={() => this.handleSocialAuthRequest(true)}>
									<img src="https://www.google.com/images/branding/googleg/1x/googleg_standard_color_128dp.png" />
									Google Sign In
								</div>
								<div className="social-btn fb" onClick={() => this.handleSocialAuthRequest(false)}>
									<img src="https://static.xx.fbcdn.net/rsrc.php/yo/r/iRmz9lCMBD2.ico" />
									Facebook Sign In
								</div>
							</div>
							
							<span className="terms-text">
								{'By signing ' + in_up_text} 
								&nbsp;you agree to our&nbsp;
								<a href="https://yashlabs.github.io/payge/payge-terms.html" target="_blank">TOS</a>
								&nbsp;and&nbsp;<a href="https://yashlabs.github.io/privacy.html" target="_blank">Privacy Policy</a>&nbsp;required for using Payge. Thank you!
							</span>
						</div>
					</div>
				</Modal>

			</div>
		)
	}
}